import { Component, OnInit } from '@angular/core';
import {MessageService} from "../../utils/message/message.service";
import {LanguagePickerService} from "../../utils/language-picker/language-picker.service";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {CatalogApiService} from "../../api/catalog-api.service";

@Component({
  selector: 'app-super-admin-catalogs',
  templateUrl: './super-admin-catalogs.component.html',
  styleUrls: ['./super-admin-catalogs.component.scss']
})
export class SuperAdminCatalogsComponent implements OnInit {

  file: any[];
  loading: boolean = false;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private message: MessageService,
    private languagePickerService: LanguagePickerService,
    private catalogApi: CatalogApiService
  ) { }

  ngOnInit(): void {
  }

  goBack(){
    this.router.navigate(['/sa/home'])
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }

  updateCatalog(){
    this.loading = true;

    if (this.file) {
      let catalog: string;

      let fileReader = new FileReader();
      fileReader.onload = () => {
        catalog = fileReader.result.toString();

        if (catalog) {
          this.catalogApi.addCatalog(catalog).subscribe((response) => {
            if (response.success) {
              this.loading = false;
              this.message.info("Catalog was updated successfully");
            } else {
              console.log(response.httpError);
              this.loading = false;
              this.message.error("Failed to update catalog");
            }
          });
        }
      };
      fileReader.readAsText(this.file[0]);
    }
    this.file = undefined;
  }

  onFileDropped($event) {
    this.prepareFile($event);
  }

  fileBrowseHandler(file) {
    this.prepareFile(file);
  }

  prepareFile(file: any[]) {
    this.file = file;
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
